import axios from "axios";
import { API_ENDPOINT, TOKEN_KEY } from "../config";
import Cookies from "universal-cookie";

// const cookies = new Cookies();
const getToken = () => {
  return sessionStorage.getItem(TOKEN_KEY);
};

export const getCouponList = async () => {
  // let token = cookies.get(TOKEN_KEY);
  let res = await axios({
    method: "GET",
    url: `${API_ENDPOINT}coupon/list`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};

export const addCoupon = async (data) => {
  // let token = cookies.get(TOKEN_KEY);
  let letsToken = sessionStorage.getItem(TOKEN_KEY);
  let fd = new FormData();
  for (var key in data) {
    if (Array.isArray(data[key])) {
      fd.append(key, JSON.stringify(data[key]));
    } else {
      fd.append(key, data[key]);
    }
  }
  let res = await axios({
    method: "POST",
    data: fd,
    url: `${API_ENDPOINT}coupon/create`,
    headers: { Authorization: letsToken ? `Bearer ${letsToken}` : "" },
  });
  return res;
};

export const updateCoupon = async (data) => {
  // let token = cookies.get(TOKEN_KEY);
  let fd = new FormData();
  for (var key in data) {
    fd.append(key, data[key]);
  }
  let res = await axios({
    method: "POST",
    data: fd,
    url: `${API_ENDPOINT}coupon/update`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};

export const deleteCoupon = async (id) => {
  // let token = cookies.get(TOKEN_KEY);
  let fd = new FormData();
  fd.append("id", id);
  let res = await axios({
    method: "POST",
    data: fd,
    url: `${API_ENDPOINT}coupon/delete`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};
